export default __webpack_public_path__ + "static/media/4-min.7a9b4d4d.jpg";